import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-086cc5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "preloader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-light border rounded p-1 d-flex align-items-center text-secondary shadow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lds-spinner" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-black mx-2 fs-4" }, " Please wait... ")
], -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.props.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("v-if", true)
  ]))
}